module.exports = __webpack_public_path__ + "img/kfzx.48a0254.svg";